import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { get, capitalize } from 'lodash';

const YearsPracticing = ({ classes, dealInterest, agentWordForCompany }) => {
  if (get(dealInterest, 'inventory_user.user.years_practicing')) {
    return (
      <div className={classes.status}>
        <strong><FormattedMessage id="profile_page.years_practicing"/></strong>
        <p>{get(dealInterest, 'inventory_user.user.years_practicing')}</p>
      </div>
    );
  }
  return <div />;
};

const styles = {
  status : {
    margin : '0px 0px 15px 25px',
    width  : 170,
  },
};

export default withStyles(styles)(YearsPracticing);
